import React, { useEffect, useState } from 'react';

const { Order } = Mobi2Go;

const PostConfirmationStatus = () => {
    useEffect(() => {
        Order.bind({
            updateAvailablePostConfirmationStatuses: onUpdateAvailablePostConfirmationStatuses,
            updateCurrentPostConfirmationStatus: onUpdateCurrentPostConfirmationStatus,
        });

        let interval = setInterval(() => Order.load(), 15000);

        return () => {
            Order.unbind(
                'updateAvailablePostConfirmationStatuses',
                onUpdateAvailablePostConfirmationStatuses
            );
            Order.unbind(
                'updateCurrentPostConfirmationStatus',
                onUpdateCurrentPostConfirmationStatus
            );

            clearInterval(interval);
        };
    }, []);

    const [
        availablePostConfirmationStatuses,
        setAvailablePostConfirmationStatuses,
    ] = useState(Order.getAvailablePostConfirmationStatuses());
    const [
        currentPostConfirmationStatus,
        setCurrentPostConfirmationStatus,
    ] = useState(Order.getCurrentPostConfirmationStatus());

    const onUpdateAvailablePostConfirmationStatuses = available_post_confirmation_statuses => {
        setAvailablePostConfirmationStatuses(
            available_post_confirmation_statuses
        );
    };

    const onUpdateCurrentPostConfirmationStatus = current_post_confirmation_status => {
        setCurrentPostConfirmationStatus(current_post_confirmation_status);
    };

    return (
        <div className="m2g-post-confirmation-status--container">
            {availablePostConfirmationStatuses.map((status, index) => {
                const currentStatusIndex = availablePostConfirmationStatuses.indexOf(
                    currentPostConfirmationStatus
                );

                const isComplete = currentStatusIndex > index;
                const isCurrent = currentStatusIndex === index;
                const isUpcoming = currentStatusIndex < index;

                return (
                    <div
                        className="m2g-post-confirmation-status-message--container"
                        key={`${status}${index}`}
                    >
                        {isComplete && (
                            <>
                                <div className="m2g-post-confirmation-status-message--complete">
                                    {status}
                                </div>
                                <div className="m2g-post-confirmation-status-message--complete-icon m2g-icon m2g-icon--tick-circle"></div>
                            </>
                        )}
                        {isCurrent && (
                            <>
                                <div className="m2g-post-confirmation-status-message--current">
                                    {status}
                                </div>
                                <div className="m2g-post-confirmation-status-message--current-icon m2g-icon m2g-icon--tick-circle"></div>
                            </>
                        )}
                        {isUpcoming && (
                            <>
                                <div className="m2g-post-confirmation-status-message--upcoming">
                                    {status}
                                </div>
                                <div className="m2g-post-confirmation-status-message--upcoming-icon m2g-icon m2g-icon--circle-grey"></div>
                            </>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default PostConfirmationStatus;
